<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>

    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Tickets Help</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex>
            <v-container  fluid grid-list-xl >
              <v-layout  justify-start row wrap>
                <v-flex>
                  <h2  class="subheading font-weight-medium">
                      A ticket is when one of the participants (seller, admin or consumer) of an order sends a message regarding an issue with the order or make an enquiry of the order. Tickets are put into 4 categories: Pending, Replied, Others and Closed.
                  </h2>
                </v-flex>
              </v-layout>
              <v-layout style="margin-bottom:20px" justify-start row wrap>
                <v-flex>
                  <ul >
                    <li><h2 class="subheading "><b>Pending</b> tickets are messages that are awaiting a reply.</h2></li>
                    <li><h2 class="subheading "><b>Replied</b> tickets as the name suggests are messages that you have replied to.</h2></li>
                    <li><h2 class="subheading "><b>Others </b>tickets are messages that are sent by other staff members with you included in it but you are not the primary sender of the message.</h2></li>
                    <li><h2 class="subheading "><b>Closed </b>tickets as the name suggests are messages that have been closed.</h2></li>
                  </ul>
                </v-flex>
              </v-layout>
              <v-layout justify-start row wrap>
                <v-flex>
                  <h1 style="margin-bottom:5px"  class="title font-weight-bold">Creating a Ticket</h1>
                  <h2 class="subheading ">There are multiple ways a ticket can be created. You can choose to create a ticket from scratch ,send the customer a message or by opening up an issue.</h2>
                </v-flex>
              </v-layout>
            </v-container>

            <!--------     CREATING TICKET FROM SCRATCH   ------->
            <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">Creating Ticket from Scratch</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                            <v-layout row wrap >
                              <v-flex xs2 md1 class="text-xs-center">
                                <div class="round-number">
                                  1
                                </div>
                              </v-flex>
                              <v-flex xs10 md11 class="text-xs-left pt-2">
                                <h3 class="subheading font-weight-bold">
                                  Navigate to the Tickets section and click on Create Ticket
                                </h3>
                                <div class="mb-5 mt-4">
                                  <img src="/static/img/help/tickets/clickCreateTicket.jpg" style="max-width:15%;" />
                                </div>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap >
                              <v-flex xs2 md1 class="text-xs-center">
                                <div class="round-number">
                                  2
                                </div>
                              </v-flex>
                              <v-flex xs10 md11 class="text-xs-left pt-2">
                                <h3 class="subheading font-weight-bold">
                                  Before creating the ticket ,you are required to obtain the <b>ORDER NUMBER</b> as well as the buyer's <b>EMAIL</b> or <b>ID</b>.
                                </h3>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap >
                              <v-flex xs2 md1 class="text-xs-center">
                                <div class="round-number">
                                  3
                                </div>
                              </v-flex>
                              <v-flex xs10 md11 class="text-xs-left pt-2">
                                <h3 class="subheading font-weight-bold">
                                  Fill in all the fields except staffs which is automatically filled in.
                                </h3>
                                <div class="mb-5 mt-4">
                                  <img src="/static/img/help/tickets/createTicketFields.jpg" style="max-width:90%;" />
                                </div>
                              </v-flex>
                            </v-layout>
                              <v-layout row wrap >
                              <v-flex xs2 md1 class="text-xs-center">
                                <div class="round-number">
                                  4
                                </div>
                              </v-flex>
                              <v-flex xs10 md11 class="text-xs-left pt-2">
                                <h3 class="subheading font-weight-bold">
                                  You can add more or remove staff from the ticket by clicking on the Staffs row and then choosing the staff you wish to add or remove.
                                </h3>
                                <div class="mb-5 mt-4">
                                  <img src="/static/img/help/sales/AddingStaffs.jpg" style="max-width:90%;" />
                                </div>
                              </v-flex>
                            </v-layout>
                              <v-layout row wrap >
                              <v-flex xs2 md1 class="text-xs-center">
                                <div class="round-number">
                                  5
                                </div>
                              </v-flex>
                              <v-flex xs10 md11 class="text-xs-left pt-2">
                                <h3 class="subheading font-weight-bold">
                                  Once you are done with filling in all the blanks, click Send Message down at the bottom
                                </h3>
                                <div class="mb-5 mt-4">
                                  <img src="/static/img/help/sales/SendMessage.jpg" style="max-width:90%;" />
                                </div>
                              </v-flex>
                            </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>

              <!--------     CREATE TICKET BY SENDING MESSAGE     ------->
              <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">Create Ticket by Sending Message</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                          <v-layout row wrap >
                            <v-flex >
                              <h3 class="subheading font-weight-bold">
                                Refer to <router-link to="/help/sales"> "Contacting a Customer"</router-link> tutorial in the Sales Help section.
                              </h3>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>

              <!--------     Create Ticket by Opening as Issue     ------->
              <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">Create Ticket by Opening an Issue</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                1
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Select the order with the item(s) you’d like to open an issue for.
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                2
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Once selected, scroll down to the items list and click on OPEN ISSUE
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/clickOpenIssue.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                3
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Then you will be prompted to fill in the title and message for the issue
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/openIssuePrompt.jpg" style="max-width:60%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                4
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Once done, click SUBMIT ISSUE.
                              </h3>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>

              <!--------     VIEW CREATED TICKET      ------->
              <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">View Created Ticket</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                          <v-layout>
                            <v-flex>
                              <h2 style="margin-bottom:20px;" class="subheading font-weight-bold">NOTE: When a ticket is newly created, it is automatically sent to the last page of the Replied section.</h2>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                1
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Navigate to the replied section in Tickets
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/clickRepliedSection.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                2
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Scroll to the bottom of the page where you can see the number navigation. Then navigate to the last page by clicking on the 5 or using the arrow until you reach the last page.
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/clickRepliedSectionLastPage.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>

              <!--------     CLOSING TICKET      ------->
              <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">Closing a Ticket</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                            <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                1
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                In the ticket section, select a ticket you would like to close.
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                2
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Once you have selected , click on the Close button located at the top.
                              </h3>
                                <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/clickCloseTicket.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                3
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                You will be prompted to give a closing message. An automatically generated message has be filled in for you incase you don’t have a message in mind.
                              </h3>
                                <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/closeTicketPrompt.jpg" style="max-width:50%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                4
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Finally click CLOSE TICKET when you are done.
                              </h3>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>

              <!--------     REOPENING TICKET      ------->
              <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">Reopening a Ticket</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                1
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Choose one of the ticket from the Closed section
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/ClosedTicketSection.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap >
                            <v-flex xs2 md1 class="text-xs-center">
                              <div class="round-number">
                                2
                              </div>
                            </v-flex>
                            <v-flex xs10 md11 class="text-xs-left pt-2">
                              <h3 class="subheading font-weight-bold">
                                Scroll down to the bottom of the page and click REOPEN TICKET
                              </h3>
                                <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/clickReopenTicket.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>

              <!--------     PRIVATE MESSAGE     ------->
              <v-layout class="mb-1">
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div> <h1 class="title font-weight-bold">Private Message</h1></div>
                      </template>
                      <v-card>
                        <v-container fluid grid-list-md>
                          <v-layout row wrap >
                            <v-flex>
                                <h3 class="subheading font-weight-bold">
                                A private message for sellers is used for sellers to talk to another seller present in the message . Do note that the admin can still see the messages you set private.
                              </h3>
                            </v-flex>
                            <v-flex>
                              <h3 class="subheading font-weight-bold">
                                In order to make a message private , simply scroll down to the bottom of the ticket of your choice, and turn on ‘Private message for seller’ before sending the message.
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/turnOnPrivateMessage.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                            <v-flex>
                              <h3 class="subheading font-weight-bold">
                                Once you’ve send the message, scroll up and you should see an icon with a tag saying ‘Private for seller’ on the right side.
                              </h3>
                              <div class="mb-5 mt-4">
                                <img src="/static/img/help/tickets/messageWithPrivateIconBeside.jpg" style="max-width:90%;" />
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>

import SideDrawer from '@/components/SideDrawer.vue'

export default {
  data () {
    return {
      drawer: false
    }
  },
  components: {
    SideDrawer
  },
  mounted () {
    this.openDrawerForDesktop()
  }
}
</script>

<style scoped>

.round-number {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #ff0000;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding-top: 3px;
}

</style>
